import React, { useEffect, useState } from "react";
import { Loader2, Trash2 } from "lucide-react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "./ui/alert-dialog";

// Imperative replacement for window.confirm: `if (!(await confirmAsync({ title }))) return;` — rendered once by <ConfirmHost /> at the app root.
let _show = null;
export function confirmAsync(opts) {
  const o = typeof opts === "string" ? { title: opts } : opts || {};
  return new Promise((resolve) => (_show ? _show({ ...o, resolve }) : resolve(window.confirm(o.title || ""))));
}

export function ConfirmHost() {
  const [req, setReq] = useState(null);
  useEffect(() => { _show = setReq; return () => { _show = null; }; }, []);
  const close = (ok) => { req?.resolve(ok); setReq(null); };
  if (!req) return null;
  const t = `${req.title} ${req.confirmLabel || ""}`;
  const VERBS = [[/\bhapus\b/i, "Hapus"], [/\bputuskan\b/i, "Putuskan"], [/\bcabut\b/i, "Cabut"], [/\bbatalkan\b/i, "Batalkan"], [/\bkeluar\b/i, "Keluar"], [/\bganti\b/i, "Ganti"], [/\bpulihkan|kembalikan\b/i, "Pulihkan"]];
  const verb = VERBS.find(([re]) => re.test(t));
  const danger = req.danger ?? (!!verb && verb[1] !== "Pulihkan");
  const label = req.confirmLabel || (verb ? verb[1] : "Lanjutkan");
  return <ConfirmDialog open onOpenChange={(o) => !o && close(false)} title={req.title} description={req.description} confirmLabel={label} danger={danger} onConfirm={() => close(true)} testid={req.testid || "confirm-dialog"} />;
}

// In-app confirmation (replaces window.confirm, which some browsers/webviews silently block → "Hapus tidak jalan").
export function ConfirmDialog({ open, onOpenChange, title, description, confirmLabel = "Hapus", danger = true, busy = false, onConfirm, testid = "confirm-dialog" }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-3xl border-[#E7ECF3] bg-white text-slate-900 shadow-2xl" data-testid={testid}>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-slate-900">{title}</AlertDialogTitle>
          {description && <AlertDialogDescription className="text-slate-500">{description}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-xl" data-testid={`${testid}-cancel`} disabled={busy}>Batal</AlertDialogCancel>
          <AlertDialogAction onClick={(e) => { e.preventDefault(); onConfirm?.(); }} disabled={busy} data-testid={`${testid}-confirm`}
            className={`flex items-center gap-2 rounded-xl ${danger ? "bg-[#EF4444] text-white hover:bg-[#DC2626]" : "btn-grad"}`}>
            {busy ? <Loader2 size={14} className="animate-spin" /> : danger && confirmLabel === "Hapus" ? <Trash2 size={14} /> : null} {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
